module.exports = __webpack_public_path__ + "static/media/afternoon-slot-icon.2b5dd2ac.svg";